import { Component } from '@angular/core';
import { Navbar } from "../../shared/navbar/navbar";
import { Footer } from "../../shared/footer/footer";
import { isPlatformBrowser } from '@angular/common';
import { Inject, PLATFORM_ID } from '@angular/core';
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'app-legal-notice',
  imports: [Footer,Navbar],
  templateUrl: './legal-notice.html',
  styleUrl: './legal-notice.css',
})
export class LegalNotice {
  constructor(@Inject(PLATFORM_ID) private platformId: Object,private titleService: Title) {
    this.titleService.setTitle('YouPrice. | Mentions légales');
  }
 ngOnInit(): void {

    if (isPlatformBrowser(this.platformId)) {
      (window as any).dataLayer = (window as any).dataLayer || [];
      (window as any).dataLayer.push({ 
        event: 'virtual_page_view',
        ecommerce: null,
        page_location: 'https://www.youprice.fr/',
        page_path: '/',
        content_group: 'HP',
        user_id: ''
      });
    }
  }
}
